import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  FieldType,
  ImageFieldSchema,
  ImageSizeFieldSchema,
  RichTextFieldSchema,
  UrlFieldSchema,
} from './Types';
import { z } from 'zod';

export const NavBarCtaTextFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('ctaText'),
  role: z.literal(FieldRole.CtaText),
});

export const NavBarCtaUrlFieldSchema = UrlFieldSchema.extend({
  name: z.literal('ctaUrl'),
  role: z.literal(FieldRole.CtaUrl),
});

export const NavBarLogoUrlFieldSchema = ImageFieldSchema.extend({
  name: z.literal('logoUrl'),
  role: z.literal(FieldRole.Logo),
});

export const NavBarLogoHrefFieldSchema = UrlFieldSchema.extend({
  name: z.literal('logoHref'),
  role: z.literal(FieldRole.Logo),
});

export const NavBarLogoSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('logoSize'),
  role: z.literal(FieldRole.Logo),
});

export const NavBarProspectLogoUrlFieldSchema = ImageFieldSchema.extend({
  name: z.literal('prospectLogoUrl'),
  role: z.literal(FieldRole.Logo),
});

export const NavBarProspectLogoSizeFieldSchema = ImageSizeFieldSchema.extend({
  name: z.literal('prospectLogoSize'),
  role: z.literal(FieldRole.Logo),
  type: z.literal(FieldType.ImageSize),
});

export const NavBarFieldSchema = z.discriminatedUnion('name', [
  NavBarCtaTextFieldSchema,
  NavBarCtaUrlFieldSchema,
  NavBarLogoUrlFieldSchema,
  NavBarLogoHrefFieldSchema,
  NavBarProspectLogoUrlFieldSchema,
  NavBarLogoSizeFieldSchema,
  NavBarProspectLogoSizeFieldSchema,
]);
export type NavBarField = z.infer<typeof NavBarFieldSchema>;

export const NavBarFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(NavBarFieldSchema),
});
export type NavBarFieldGroup = z.infer<typeof NavBarFieldGroupSchema>;

export const NavBarBlockOptionsSchema = z.object({
  style: z
    .object({
      backgroundColor: z.string().optional(),
    })
    .optional(),
  layout: z.literal('standard').optional(),
  colorScheme: ColorSchemeSchema.optional(),
  prospectLogoEnabled: z.boolean().optional(),
});
export type NavBarBlockOptions = z.infer<typeof NavBarBlockOptionsSchema>;

export const NavBarBlockConfigSchema = z.object({
  options: NavBarBlockOptionsSchema,
  type: z.literal(BlockType.NavBar),
  fieldGroups: z.tuple([NavBarFieldGroupSchema]).rest(NavBarFieldGroupSchema),
  version: z.literal(1),
});

export type NavBarBlockConfig = z.infer<typeof NavBarBlockConfigSchema>;
